<template>
    <div id="asset_defect_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="AssetDefectHeader">Import Data</span>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content import-data">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" id="importFile" class="addinspectionForm basic-form-container">
                                <div class="form-row row-cols-md-3 row-cols-1">
                                    <div class="col form-group">
                                        <div class="left-section import-left-section">
                                            <label class="control-label require" for="name">Import Data For Module : </label>
                                            <v-select placeholder="Select Module" v-model="moduleId" label="text" :options="moduleArr"></v-select>
                                            <div class="field-error">{{ module_error_msg }}</div>
                                        </div>
                                    </div>
                                    <div class="col form-group " v-if="fileName != ''">
                                        <label class="control-label"> Download file for {{moduleName}} Module </label><br/>
                                        <a href="javascript:void(0)" v-on:click="downloadSample()" class="color-blue mt-2 d-block"> <i class="fp-text-document"></i> {{fileName}} </a>
                                    </div>
                                </div>
                                <div class="form-row row-cols-md-2 row-cols-1 mt-4">
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">File:</label>
                                        <input id="typeImage" type="file" @change="onFileChanged">
                                        <div class="field-error">{{ file_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="btn-groups mt-5">
                                    <button type="submit" id="CreatePurchaseOrderBtn" class="btn btn-primary" v-on:click.prevent="importReport" > Next <i class="fp-right-arrow" style="font-size:20px;padding-left:5px;"></i>
                                    </button>
                                </div>
                                <span class="field-error">{{error}}</span>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';


export default {
  name: "ContractCreate",

  metaInfo() {
      return {
          title: "Import Data | " +process.env.COPYRIGHT_NAME
      }
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    loading:false,
    permissions: [],
    cantAccessPage: "",
    moduleArr: [],
    moduleId: "",
    module_error_msg: "",
    file_error_msg: "",
    error: "",
    fileName:"",
    flagFile:"",
    file:"",
    selectedFile:"",
    moduleName:"",
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {
            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'import_data') {
                        self.cantAccessPage = true;

                    }
                }
            }

        },
        moduleId: function(newVal,oldVal){
            // alert(newVal.text);
            var self = this;
            if(newVal == null){
                self.flagFile = true;
                self.fileName = '';
                $('.import-left-section').removeClass('imp-border');
                return;
            }
            self.moduleName = newVal.text;
                self.loading = true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/generate_excel_by_module",
                    type: "POST",
                    data:{
                        module:newVal.text
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);
                        self.file = data.content.web;
                        if(self.file != "" && self.file != undefined){
                            self.flagFile = true;
                            self.fileName = data.content.file;
                            if(self.fileName != ''){
                                $('.import-left-section').addClass('imp-border');
                            }
                        }
                        console.log(data);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'import-generate-excel')
                        // if (jqXHR.status == 0) {
                        //     self.errorMsg = "Remote server cannot be reached";
                        // } else {
                        //     //redirect to login page if user not authenticated
                        //     if (jqXHR.status == 401) {
                        //         //clear previous data
                        //         localStorage.removeItem("user_obj");
                        //         localStorage.removeItem("tkn");

                        //         self.$router.push("/");
                        //     }
                        //     self.error = jqXHR.responseJSON.message;
                        // }
                    }
                });
        }

  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.getModules();
        self.loadFieldData(['location','vom','source','status','shop']);
  },
  methods: {
      downloadSample(){
        var self = this;
        // alert(self.file);
        // console.log()
        var docPath = self.file;
        var save = document.createElement('a');
        save.href = docPath;
        save.download = docPath;
        save.target = '_blank';
        document.body.appendChild(save);
        save.click();
        document.body.removeChild(save);
      },
      getModules() {
            var self = this;
                self.loading = true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/get_modules_by_package",
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        self.moduleArr = data;
                        console.log(data);
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'get-module-by-package')
                    }
                });
            },
        onFileChanged (event) {
            const file = event.target.files[0]
            console.log(event.target);
            var self = this;
            self.selectedFile = file;
            self.notfound = false;
            self.notFoundArr = [];
            console.log(self.selectedFile);
        },
        importReport: function(){
            var self = this;
            var formData = new FormData();
            if(self.moduleId == null || !self.moduleId.value || self.moduleId.value == ''){
                self.$swal('','Please Select A Module','info');
                return;
            }
            formData.append('myFile', self.selectedFile);
            if (self.moduleId.text == "GlAccount") {
                formData.append('module', "GLAccount");
            }else{
                formData.append('module', self.moduleId.text);
            }

            self.loading = true;
            $('#myButton').text('Fetching...');
            $('#myButton').prop('disabled',true);
            $.ajax({
            url: process.env.ROOT_API + "/fetch_excel_fields",
            type: "POST",
            // data: {name: self.name, code: self.code, is_default: self.checkboxValue, id: segments[3]},
            data: formData,
            headers: this.ajxHeaders,
            crossDomain: true,
            processData: false,
            contentType: false,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                localStorage.setItem('fileName',data.content);
                // alert(self.moduleId.text);
                self.$router.push('/import-data-content/'+self.moduleId.text);
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                $('#myButton').text('Import');
                $('#myButton').prop('disabled',false);
                console.log(jqXHR.responseJSON);
                self.$swal('',jqXHR.responseJSON.message,'error');

                self.generateStatusCodeMessage(jqXHR,true,'fetch-excel-field')
            }
        });
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ImportData.vue